class ShippingEstimator {

  constructor() {

    this.button =
      document.getElementById(
        'EstimateShippingBtn'
      );

    if (!this.button) return;

    this.results =
      document.getElementById(
        'ShippingResults'
      );

    this.delivery =
      document.getElementById(
        'DeliveryEstimate'
      );

    this.country =
      document.getElementById(
        'ShippingCountry'
      );
      this.province =
  document.getElementById(
    'ShippingProvince'
  );

    this.locationInput =
      document.getElementById(
        'ShippingLocation'
      );

    this.zip =
      document.getElementById(
        'ShippingZip'
      );

    this.lookup =
      document.getElementById(
        'PostcodeLookup'
      );

    this.variantInput =
      document.querySelector(
        'input[name="id"]'
      );

    this.postcodeData = {};

    this.city = '';

    this.dropdown = null;

    this.lookupRequestId = 0;

    this.bindEvents();

    this.setButtonDisabled(
      true
    );

    this.initGooglePlaces();
  }

  bindEvents() {

    this.button.addEventListener(
      'click',
      () => this.calculate()
    );

    document.addEventListener(
      'variant:change',
      () => {
        this.clearResults();
      }
    );
  }

  setButtonDisabled(
    disabled
  ) {

    this.button.disabled =
      disabled;

    this.button.setAttribute(
      'aria-disabled',
      disabled ? 'true' : 'false'
    );
  }

  setInputLoading(
    state
  ) {

    this.locationInput
      .parentNode
      .classList.toggle(
      'is-loading',
      state
    );
  }

  ensureDropdown() {

    if (this.dropdown) {
      return this.dropdown;
    }

    this.dropdown =
      document.getElementById(
        'ShippingSuggestions'
      );

    if (!this.dropdown) {

      this.dropdown =
        document.createElement(
          'div'
        );

      this.dropdown.id =
        'ShippingSuggestions';

      this.dropdown.className =
        'shipping-suggestions';

      this.locationInput
        .parentNode
        .appendChild(
          this.dropdown
        );
    }

    return this.dropdown;
  }

  clearDropdown() {

    const dropdown =
      this.ensureDropdown();

    dropdown.innerHTML = '';
    dropdown.style.display = 'none';
  }

  showDropdown() {

    this.ensureDropdown().style.display =
      'block';
  }

  resetSelection() {

    this.zip.value = '';
    this.city = '';

    if (this.province) {
      this.province.value = '';
    }

    this.lookup.innerHTML = '';

    this.setButtonDisabled(
      true
    );
  }

  updateDeliveryText(
    formattedAddress
  ) {

    $('.delivery-to').html(
      formattedAddress
    );
  }

  async selectLocation(
    location,
    autoSubmit = false
  ) {

    const formattedAddress =
      `${location.suburb}, ${location.state} ${location.postcode}, Australia`;

    this.locationInput.value =
      formattedAddress;

    this.updateDeliveryText(
      formattedAddress
    );

    this.zip.value =
      location.postcode;

    this.city =
      location.suburb;

    if (this.province) {
      this.province.value =
        location.state;
    }

    this.lookup.textContent =
      `${location.suburb}, ${location.state} ${location.postcode}`;

    this.clearDropdown();
    this.setInputLoading(
      false
    );
    this.setButtonDisabled(
      false
    );

    if (autoSubmit) {
      await this.calculate();
    }
  }

  renderLocationSuggestions(
    locations
  ) {

    const dropdown =
      this.ensureDropdown();

    dropdown.innerHTML = '';

    locations.forEach(
      location => {

        const button =
          document.createElement(
            'button'
          );

        button.type = 'button';
        button.className =
          'shipping-suggestion';
        button.textContent =
          `${location.suburb}, ${location.state} ${location.postcode}`;

        button.addEventListener(
          'click',
          async () => {
            await this.selectLocation(
              location,
              true
            );
          }
        );

        dropdown.appendChild(
          button
        );
      }
    );

    if (locations.length) {
      this.showDropdown();
    } else {
      this.clearDropdown();
    }
  }

  async handlePostcodeInput(
    value
  ) {

    const requestId =
      ++this.lookupRequestId;

    this.resetSelection();
    this.clearResults();
    this.clearDropdown();

    if (!value.length) {
      this.setInputLoading(
        false
      );
      return;
    }

    this.setInputLoading(
      true
    );

    const postcodeLocations =
      this.getMatchingPostcodeLocations(
        value
      );

    if (
      requestId !== this.lookupRequestId
    ) {
      return;
    }

    if (!postcodeLocations.length) {
      this.setInputLoading(
        false
      );
      return;
    }

    if (
      value.length === 4 &&
      postcodeLocations.length === 1
    ) {
      await this.selectLocation(
        postcodeLocations[0],
        true
      );
      return;
    }

    this.renderLocationSuggestions(
      postcodeLocations
    );

    this.setInputLoading(
      false
    );
  }

  async initGooglePlaces() {

  try {

    if (window.AU_POSTCODES_URL) {

      try {

        const response = await fetch(
          window.AU_POSTCODES_URL
        );

        if (!response.ok) {
          throw new Error('Unable to load postcode data');
        }

        this.postcodeData = await response.json();

      } catch (error) {

        console.error(
          'Local postcode data failed to load',
          error
        );

      }

    }

    let debounceTimer;

    this.ensureDropdown();

    this.locationInput.addEventListener(
      "input",
      (e) => {

        clearTimeout(
          debounceTimer
        );

        const value =
          e.target.value
            .replace(/\D/g, "")
            .slice(0, 4);

        e.target.value = value;

        if (
          value.length < 1
        ) {

          this.lookupRequestId += 1;
          this.resetSelection();
          this.clearDropdown();
          this.clearResults();
          this.setInputLoading(
            false
          );

          return;
        }

        this.setInputLoading(
          true
        );

        debounceTimer =
          setTimeout(
            async () => {

              try {
                await this.handlePostcodeInput(
                  value
                );

              } catch (
                error
              ) {

                console.error(
                  "Places API Error",
                  error
                );

              }

            },
            500
          );

      }
    );

    document.addEventListener(
      "click",
      (event) => {

        if (
          !event.target.closest(
            ".shipping-location-wrapper"
          )
        ) {

          this.clearDropdown();

        }

      }
    );

  } catch(error) {

    console.error(
      "Google Places init failed",
      error
    );

  }

}

  getMatchingPostcodeLocations(
    postcode
  ) {

    if (
      !postcode ||
      !/^\d{3,4}$/.test(
        postcode
      )
    ) {
      return [];
    }

    const matchingPostcodes =
      postcode.length === 4
        ? [postcode]
        : Object.keys(this.postcodeData)
          .filter(postcodeKey =>
            postcodeKey.startsWith(
              postcode
            )
          )
          .sort();

    return matchingPostcodes
      .flatMap(postcodeKey =>
        this.getPostcodeLocations(
          this.postcodeData[
            postcodeKey
          ],
          postcodeKey
        )
      );

  }

  getPostcodeLocations(
    postcodeRecord,
    postcode
  ) {

    if (!postcodeRecord) {
      return [];
    }

    if (
      Array.isArray(
        postcodeRecord.locations
      )
    ) {

      return postcodeRecord.locations
        .map(location => ({
          postcode,
          suburb:
            location.suburb ||
            location.locality ||
            location.city ||
            '',
          state:
            location.state ||
            postcodeRecord.state ||
            ''
        }))
        .filter(location =>
          location.suburb &&
          location.state
        );

    }

    if (
      Array.isArray(
        postcodeRecord.suburbs
      )
    ) {

      return postcodeRecord.suburbs
        .map(suburb => ({
          postcode,
          suburb,
          state:
            postcodeRecord.state ||
            ''
        }))
        .filter(location =>
          location.suburb &&
          location.state
        );

    }

    return [];
  }

  setLoading(state) {

    const spinner =
      this.button.querySelector(
        '.btn-spinner'
      );

    const text =
      this.button.querySelector(
        '.btn-text'
      );

    if (state) {

      document
  .getElementById('EstimateShippingBtn')
  .setAttribute('aria-busy', 'true');

      this.button.disabled =
        true;

    } else {

      document
  .getElementById('EstimateShippingBtn')
  .setAttribute('aria-busy', 'false');

      this.setButtonDisabled(
        !(
          this.zip.value &&
          this.city
        )
      );
    }
  }

  clearResults() {

    this.results.innerHTML = '';

    this.delivery.innerHTML = '';
    $('.shipping-estimator').removeClass('show-results');
  }

  async addTempItem(
    variantId
  ) {

    const response =
      await fetch(
        '/cart/add.js',
        {
          method:'POST',
          headers:{
            'Content-Type':
            'application/json'
          },
          body:JSON.stringify({
            id:variantId,
            quantity:1
          })
        }
      );

    return response.json();
  }

  async removeTempItem(
    variantId
  ) {

    const cart =
      await fetch('/cart.js')
      .then(r => r.json());

    const item =
      cart.items.find(
        item =>
          item.variant_id ==
          variantId
      );

    if (!item) return;
const newQty = item.quantity - 1;
    await fetch(
      '/cart/change.js',
      {
        method:'POST',
        headers:{
          'Content-Type':
          'application/json'
        },
        body:JSON.stringify({
          id:item.key,
          quantity:newQty
        })
      }
    );
  }

  async fetchRates(
    country,
    province,
    zip,
    city
  ) {

    const params = new URLSearchParams({
      'shipping_address[zip]': zip,
      'shipping_address[country]': country,
      'shipping_address[province]': province,
      'shipping_address[city]': city
    });

    const response =
      await fetch(
        `/cart/shipping_rates.json?${params.toString()}`
      );

    return response.json();
  }

  renderRates(rates) {

    if (!rates.length) {

      this.results.innerHTML =
        'No shipping methods available';

      return;
    }

    let html = '';

    rates.forEach(rate => {

      html += `
        <div class="shipping-rate">

          <div>
            ${rate.name}
          </div>

          <div>
            $${rate.price}
          </div>

        </div>
      `;
    });

    this.results.innerHTML =
      html;
      $('.shipping-estimator').addClass('show-results');
  }

  renderDeliveryEstimate(
    rates
  ) {

    const hasExpress =
      rates.some(rate =>
        rate.name
        .toLowerCase()
        .includes('express')
      );

    this.delivery.innerHTML =
      hasExpress
      ? 'Express delivery available: 2–4 business days'
      : 'Estimated delivery: 5–7 business days';
  }

  async calculate() {

    try {

      const zip =
        this.zip.value;

      if (!zip) {
        return;
      }
      const province =
  this.province.value;

       this.setLoading(true);

      this.clearResults();

      const variantId =
        this.variantInput.value;
      document.documentElement.classList.add(
  'shipping-estimator-running'
);
window.__shippingEstimatorRunning = true;
      await this.addTempItem(
        variantId
      );
      
      const data =
        await this.fetchRates(
          'AU',
          province,
          zip,
          this.city
        );
        
      const rates =
        data.shipping_rates || [];

      this.renderRates(
        rates
      );

      // this.renderDeliveryEstimate(
      //   rates
      // );

      await this.removeTempItem(
        variantId
      );
window.__shippingEstimatorRunning = false;
    } catch(error) {

      console.error(error);

      this.results.innerHTML =
        'Unable to estimate shipping';

    } finally {
       this.setLoading(false);
       document.documentElement.classList.remove(
            'shipping-estimator-running'
          );
          
      
    }
  }
}

window.addEventListener(
  'load',
  () => {

    const waitForGoogle = () => {

      new ShippingEstimator();

    };

    waitForGoogle();

  }
);

(function() {

  const originalDispatch =
    document.dispatchEvent;

  document.dispatchEvent =
    function(event) {

      if (
        document.documentElement.classList.contains(
          'shipping-estimator-running'
        ) &&
        event.type === 'rebuy:cart.change'
      ) {
        console.log(
          'Blocked rebuy:cart.change'
        );
        return true;
      }

      return originalDispatch.call(
        this,
        event
      );
    };

})();
